export const unchecked =
  'M 239,17.00001 239,239 l -221.999999,0 0,-221.99999 M 256,1.08e-5 0,1.08e-5 0,256 l 256,0 z'
